import { render } from "./PainelLoginA.vue?vue&type=template&id=3650eaba&scoped=true"
import script from "./PainelLoginA.vue?vue&type=script&lang=js"
export * from "./PainelLoginA.vue?vue&type=script&lang=js"

import "./PainelLoginA.vue?vue&type=style&index=0&id=3650eaba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3650eaba"]])

export default __exports__